"use client";
import { Box } from "@mui/material";
import FeaturesSection from "@/components/sections/Home/FeaturesSection";
import HeroSection from "@/components/sections/Home/HeroSection";
import IntegrationSection from "@/components/sections/Home/IntegrationSection";
import HowItWorksSection from "@/components/sections/Home/HowItWorksSection";
import TestimonialSection from "@/components/sections/Home/TestimonialSection";
import ChatWithUsSection from "@/components/sections/Home/ChatWithUsSection";

export default function Home() {
  return (
    <Box>
      <HeroSection />
      <FeaturesSection />
      <IntegrationSection />
      <HowItWorksSection />
      <TestimonialSection />
      <ChatWithUsSection />
    </Box>
  );
}
